import { FIELD_TYPES } from "./metadata.constants.js";
export const COLUMN_DEFAULTS = {
  [FIELD_TYPES.TEXT]: {
    defaultWidth: 200,
    minWidth: 100
  },
  [FIELD_TYPES.TEXT_AREA]: {
    defaultWidth: 200,
    minWidth: 200
  },
  [FIELD_TYPES.NUMBER]: {
    defaultWidth: 200,
    minWidth: 100
  },
  [FIELD_TYPES.CURRENCY]: {
    defaultWidth: 200,
    minWidth: 100
  },
  [FIELD_TYPES.DATE]: {
    defaultWidth: 120,
    minWidth: 100
  },
  [FIELD_TYPES.DATE_TIME]: {
    defaultWidth: 160,
    minWidth: 100
  },
  [FIELD_TYPES.EMAIL]: {
    defaultWidth: 200,
    minWidth: 100
  },
  [FIELD_TYPES.BOOLEAN]: {
    defaultWidth: 100,
    minWidth: 100
  },
  [FIELD_TYPES.ATTACHMENT]: {
    defaultWidth: 200,
    minWidth: 100
  },
  [FIELD_TYPES.SELECT]: {
    defaultWidth: 200,
    minWidth: 100
  },
  [FIELD_TYPES.MULTI_SELECT]: {
    defaultWidth: 320,
    minWidth: 100
  },
  [FIELD_TYPES.USER]: {
    defaultWidth: 200,
    minWidth: 100
  },
  [FIELD_TYPES.MULTI_USER]: {
    defaultWidth: 320,
    minWidth: 100
  },
  [FIELD_TYPES.SLIDER]: {
    defaultWidth: 200,
    minWidth: 100
  },
  [FIELD_TYPES.STAR_RATING]: {
    defaultWidth: 160,
    minWidth: 160
  },
  [FIELD_TYPES.SIGNATURE]: {
    defaultWidth: 200,
    minWidth: 200
  },
  [FIELD_TYPES.CHECK_LIST]: {
    defaultWidth: 320,
    minWidth: 200
  },
  [FIELD_TYPES.IMAGE]: {
    defaultWidth: 100,
    minWidth: 100
  },
  [FIELD_TYPES.REFERENCE]: {
    defaultWidth: 400,
    minWidth: 200
  },
  [FIELD_TYPES.REMOTE_LOOKUP]: {
    defaultWidth: 400,
    minWidth: 200
  },
  [FIELD_TYPES.JSON]: {
    defaultWidth: 400,
    minWidth: 200
  },
  [FIELD_TYPES.XML]: {
    defaultWidth: 400,
    minWidth: 200
  },
  [FIELD_TYPES.CHECK_BOX]: {
    defaultWidth: 320,
    minWidth: 150
  },
  [FIELD_TYPES.AGGREGATION]: {
    defaultWidth: 400,
    minWidth: 100
  },
  [FIELD_TYPES.RADIO]: {
    defaultWidth: 200,
    minWidth: 100
  }
};

export const FIXEDSIDE = {
  LEFT: "left",
  RIGHT: "right"
};
export const PINNED_COLUMNS_STORE = "PinnedColumnsStore";
export const CHILD_TABLE_STORE = "ChildTableStore";
